module.exports = __webpack_public_path__ + "static/media/setup.1e89068f.jpg";